export default __webpack_public_path__ + "assets/mp3/c8f0cd4c014a920f4c79ff781316c0b2.mp3";